import clsx from 'clsx';

import { MantineSize } from '@mantine/core';

import classes from './ItemsPicker.module.css';

export const ItemsPickerOverrideClassNames = (
  size: MantineSize,
  disabled: boolean
) => {
  return {
    badge: clsx(classes.badgeStyles, {
      [classes.badgeStylesSmall]: size === 'xs' || size === 'sm' || size === 'md',
      [classes.badgeDisabled]: disabled
    })
  };
};
